// export let hh = "hamza"

export default {
  Practitioner: {
    English: "Practitioner",
    German: "Anwender",
    Portuguese: "Terapeuta",
    Japanese:"施術士",
  },
  Practitioners: {
    English: "Practitioners",
    German: "Anwender",
    Portuguese: "Terapeutas",
    Japanese:"施術士",
  },
  practitioner: {
    English: "practitioner",
    German: "anwender",
    Portuguese: "Terapeuta",
    Japanese:"施術士",
  },
  practitioners: {
    English: "practitioners",
    German: "anwender",
    Portuguese: "Terapeutas",
    Japanese:"施術士",
  },
  Instructor: {
    English: "Instructor",
    German: "Ausbilder",
    Portuguese: "Instructor",
  },
  forAnimals: {
    English: "for Animals",
    Japanese:"動物用",
  },
  instructor: {
    English: "instructor",
    German: "ausbilder",
    Portuguese: "instructor",
  },
  Instructors: {
    English: "Instructors",
    German: "Ausbilders",
    Portuguese: "Instructors",
  },
  Instructorss: {
    English: "Instructor's",
    German: "Ausbilder's",
    Portuguese: "Instructor's",
  },
  instructorss: {
    English: "instructor's",
    German: "ausbilder's",
    Portuguese: "instructor's",
  },
  instructors: {
    English: "instructors",
    German: "ausbilders",
    Portuguese: "instructors",
  },
  Membership: {
    English: "Membership",
    Portuguese: "Filiação",
  },
  SelfStudyCourse: {
    English: "Self-Study Course",
    Portuguese: "Curso de Estudo Independente",
  },
  SelfStudyCourses: {
    English: "Self-Study Courses",
    Portuguese: "Cursos de Estudo Independente",
  },
  BreakThrough: {
    English: "BreakThrough",
    Portuguese: "BreakThrough",
    Japanese: "ブレイクスルー",
  },
  Manuals:{
    English: "Manuals",
    German: "Lehrbucher",
  },
  Manual:{
    English: "Manual",
    German: "Lehrbuch",
  },
  manuals:{
    English: "manuals",
    German: "lehrbucher",
  },
  profile:{
    English: "profile",
    German: "profil",
  },
  Profile:{
    English: "Profile",
    German: "Profil",
  },
  Credentials:{
    English: "Credentials",
    German: "Qualifikationen",
  },
  credential:{
    English: "credential",
    German: "Qualifikationen",
  },
  credentials:{
    English: "credentials",
    German: "qualifikationen",
  },

  Starter:{
    English: "Starter",
    German: "Basis",
    Portuguese: "Starter",
  },
  Access:{
    English: "Access",
    Portuguese: "Access",
  },
  Standard:{
    English: "Standard",
    Portuguese: "Standard",
    Japanese: "スタンダード",
  },
  PractitionerMembership: {
    English: "Practitioner",
    Portuguese: "Practitioner",
    German: "Anwender",
    Japanese:"施術士",
  },
  InvalidCredentials:{
    English: "Invalid Credentials",
    German: "Ungültiger Qualifikationen",
  },
  IBAInstructors:{
    English: "IBA Instructors",
    German: "IBA Ausbilders",
  },
  PractitionerMember:{
    English: "Practitioner Member",
    German: "Anwender Mitglied",
  },
  PractitionerType:{
    English: "Practitioner Type",
    German: "Anwender Type",
  },
  ProfileCredentials:{
    English: "Profile/Credentials",
    German: "Profil/Qualifikationen",
  },
  IBAMembership: {
    English: "IBA Membership ",
    Portuguese: "Associação e ",
  },
  MembershipBenefits: {
    English: "and Benefits",
    Portuguese: "Benefícios da IBA",
  },
  // IBAMembershipAndBenefits: {
  //   English: "IBA Membership and Benefits",
  //   Portuguese: "Associação e Beneficios da IBA",
  // },
  HaveQuestion: {
    English: "Have a question?",
    Portuguese: "Tem alguma pergunta?",
    // Japanese: "質問がありますか？",
  },
  mobileNumber: {
    English: "Mobile Number *",
    Portuguese: "Numero de celular",
  },
  mobilenumber:{
    English: "mobile number",
    Portuguese: "Numero de celular",
  },
  BridgingTheGap: {
    English: "Bridging the gap",
    Portuguese: "Reduzindo a distância",
  },
  
  UpgradeIBAMembership: {
    English: "Upgrade IBA Membership",
    Portuguese: "Atualizar filiacao da IBA",
  },
  CurrentMembershipSummary: {
    English: "Current Membership Summary",
    Portuguese: "Quadro Atual de Membros",
  },
  hardshipMembership: {
    English: "hardship membership",
    Portuguese: "opções de bolsa",
  },
  InviteCoordinator: {
    English: "Invite Coordinator",
    Portuguese: "convidar coordenador",
  },
  InviteCoordinatorAllCapital: {
    English: "INVITE COORDINATOR",
    Portuguese: "convidar coordenador",
  },
  PaRamaCampus: {
    English: "PaRama Campus",
    Portuguese: "PaRama Campus",
  },
  GoToPaRamaCampus: {
    English: "Go to PaRama Campus",
    Japanese: "パラマキャンパスへ移動",
  },
  Active:{
    English: "Active",
    Japanese: "活動中",
  },
  Inactive:{
    English: "Inactive",
    Japanese: "非活動中",
  },
  Ihavebeeninvitedtotrainby:{
    English: "I have been invited to train by",
    Japanese: "トレーニングに誘った人は誰ですか？",
  },
  forhumansoranimals:{
    English: "for humans or animals",
    Japanese: "人間または動物のための",
  },
  AdvancedIntegration:{
    English: "Advanced Integration",
    Japanese: "上級統合",
  },
  Apply:{
    English: "Apply",
    Japanese: "申請",
  },
  Bio:{
    English: "Bio",
    Japanese: "プロフィール欄",
  },
  bio:{
    English: "bio",
    Japanese: "プロフィール欄",
  },
  BodyTalk:{
    English: "BodyTalk",
    Japanese: "ボディートーク",
  },
  MindScape:{
    English: "MindScape",
    Japanese: "マインドスケープ",
  },
  bodyTalk:{
    English: "bodyTalk",
    Japanese: "ボディートーク",
  },
  
  BodyTalkAccess:{
    English: "BodyTalk Access",
    Japanese: "ボディートークアクセス",
  },
  BodytalkFundamentals:{
    English: "BodyTalk Fundamentals",
    Japanese: "ボディートーク基礎",
  },
  BodyTalkFundamentalsIntegration:{
    English: "BodyTalk Fundamentals Integration",
    Japanese: "ボディートーク基礎統合",
  },
  // BodyTalkAccessforAnimals:{
  //   English: "BodyTalk Access for Animals",
  //   Japanese: "動物のためのボディートークアクセス",
  // },
  BodyTalkAdvancedModules:{
    English: "BodyTalk Advanced Modules",
    Japanese: "ボディートーク上級モジュール",
  },
  BodyTalkDevelopment:{
    English: "BodyTalk Development",
    Japanese: "ボディートークの開発",
  },
  BodyTalkforAnimals:{
    English: "BodyTalk for Animals",
    Japanese: "動物のためのボディートーク",
  },
  BodyTalkforAnimalsPractitioner:{
    English: "BodyTalk for Animals Practitioner",
    Japanese: "動物のためのボディートーク施術士",
  },
  advancedBodyTalk:{
    English: "advanced BodyTalk",
    Japanese: "上級ボディートーク",
  },
  BodyTalkPractitioners:{
    English: "BodyTalk Practitioners",
    Japanese: "ボディートーク施術士",
    Portuguese: "Terapeutas de BodyTalk",
  },
  Certified:{
    English: "Certified",
    German: "Zertifizierter",
    Portuguese: "Certificado",
  },
  certified:{
    English: "certified",
    German: "zertifizierter",
    Portuguese: "certificado",
  },
  Advanced:{
    English: "Advanced",
    German: "Fortgeschrittener",
    Portuguese: "Avançado",
    Japanese: "高度な",
  },
  advanced:{
    English: "advanced",
    German: "fortgeschrittener",
    Portuguese: "avançado",
  },
  BodyTalkPractitioner:{
    English: "BodyTalk Practitioner",
    Portuguese: "Terapeuta de BodyTalk",
  },
  BreakThroughPractitioners:{
    English: "BreakThrough Practitioners",
    Japanese: "ブレイクスルー施術士",
    Portuguese: "Terapeutas de BreakThrough",
  },
  AdvancedCertifiedBodyTalkPractitioner:{
    English: "Advanced Certified BodyTalk Practitioner",
    Japanese: "上級認定ボディートーク施術士",
  },
  CertifiedBodyTalkPractitioner:{
    English: "Certified BodyTalk Practitioner",
    Japanese: "認定ボディートーク施術士",
  },
  BecomeaconfidentCBP:{
    English: "Become a confident CBP",
    Japanese: "自信に満ちたCBPになる",
  },
  BodyTalkFundamantalsTrainer:{
    English: "BodyTalk Fundamantals Trainer",
    Japanese: "ボディートーク基礎インストラクター",
  },
  BodyTalkInstructorFundamentals:{
    English: "BodyTalk Instructor - Fundamentals",
    Japanese: "ボディートーク基礎インストラクター",
  },
  CBPAs:{
    English: "CBP-As",
    Japanese: "CBP-A",
  },
  MatrixDynamics:{
    English: "Matrix Dynamics",
    Japanese: "マトリックス力学",
  },
  Close:{
    English: "Close",
    Japanese: "閉じる",
  },
  CertifiedBodyTalkforAnimalsPractitioner:{
    English: "Certified BodyTalk for Animals Practitioner",
    // Japanese: "認定ボディートークアニマル施術士",
    Japanese: "認定アニマルボディートーク施術士",
  },
  conversation:{
    English: "conversation",
    Japanese: "対話",
  },
  committing:{
    English: "committing",
    Japanese: "決断",
  },
  Delete:{
    English: "delete",
    Japanese: "削除",
  },
  entrylevel:{
    English: "entry level",
    Japanese: "入門レベル",
  },
  EssentialFoundersCourses:{
    English: "Essential Founder's Courses",
    Japanese: "創始者コース",
  },
  fastidious:{
    English: "fastidious",
    Japanese: "几帳面な",
  },
  // Yourpathmayvary:{
  //   English: "Your path may vary",
  //   Japanese: "あなたの進む道は様々かもしれない",
  // },
  YearlyFee:{
    English: "Yearly Fee",
    Japanese: "年会費",
  },
  WholeHealthcare:{
    English: "Whole Healthcare",
    // Japanese: "全人的ヘルスケア",
    Japanese: "全人的ヘルスケア",
  },
  ViewCertificate:{
    English: "View Certificate",
    Japanese: "証明書を見る",
  },
  HealthcareatHome:{
    English: "Healthcare at Home",
    Japanese: "家庭でのヘルスケア",
  },
  enhancededucationalsupport:{
    English: "enhanced educational support",
    Japanese: "教育サポートの充実",
  },
  NewsBlog:{
    English: "News/Blog",
    Japanese: "ニュース／ブログ",
  },
  Cortices:{
    English: "Cortices",
    Japanese: "大脳皮質",
  },
  Ethics:{
    English: "Ethics",
    Japanese: "倫理規定",
  },
  ethics:{
    English: "ethics",
    Japanese: "倫理規定",
  },
  unlearning:{
    English: "unlearning",
    // Japanese: "学びをやめる",
    Japanese: "学習棄却",
  },
  Themanbehindthevision:{
    English: "The man behind the vision",
    Japanese: "ビジョンリーダー",
  },
  // StudyGroups:{
  //   English: "Study Groups",
  //   Japanese: "スタディグループ",
  // },
  room:{
    English: "room",
    Japanese: "場所",
  },
  requirements:{
    English: "requirements",
    Japanese: "条件",
  },
  Financial:{
    English: "Financial",
    Japanese: "財務",
  },
  Store:{
    English: "Store",
    Japanese: "ストア",
  },
  student:{
    English: "student",
    Japanese: "生徒",
  },
  Students:{
    English: "Students",
    Japanese: "生徒",
  },
  refinement:{
    English: "refinement",
    Japanese: "研鑽",
  },
  TimeEnd:{
    English: "Time End",
    Japanese: "終了時間",
  },
  SupervisingInstructor:{
    English: "Supervising Instructor",
    Japanese: "指導教員",
  },
  Supervisinginstructor:{
    English: "Supervising instructor",
    Japanese: "指導教員",
  },
  TrainingGuidelinesandRequirements:{
    English: "Training Guidelines and Requirements",
    Japanese: "トレーニングのガイドラインと必要条件",
  },
  theTrainerofBodyTalkAccessTrainers:{
    English: "the Trainer of BodyTalk Access Trainers",
    Japanese: "アクセストレーナーのトレーナー",
  },
  TrainerofBodyTalkAccessTrainers:{
    English: "Trainer of BodyTalk Access Trainers",
    Japanese: "アクセストレーナーのトレーナー",
  },
  TheessentialsofadvancedBodyTalktraining:{
    English: "The essentials of advanced BodyTalk training",
    Japanese: "上級ボディトーク・トレーニングの要点",
  },
  SupervisingInstructorsName:{
    English: "Supervising Instructor's name",
    Japanese: "指導教員の名前",
  },
  Publicpresentations:{
    English: "Public presentations",
    Japanese: "説明会",
  },
  PublicPresentations:{
    English: "Public Presentations",
    Japanese: "説明会",
  },
  Lectureswithourinstructors:{
    English: "Lectures with our instructors",
    Japanese: "インストラクターによる講義",
  },
  publiceducation:{
    English: "public education",
    Japanese: "一般向けの教育",
  },
  public:{
    English: "public",
    Japanese: "一般",
  },
  Products:{
    English: "Products",
    Japanese: "商品",
  },
  pathway:{
    English: "pathway",
    Japanese: "道のり",
  },
  MacrocosmicBodyMind:{
    English: "Macrocosmic BodyMind",
    Japanese: "心身の大宇宙",
  },
  Masking:{
    English: '"Masking"',
    Japanese: "「マスク」",
  },
  Location:{
    English: "Location",
    Japanese: "場所",
  },
  Locations:{
    English: "Locations",
    Japanese: "場所",
  },
  library:{
    English: "library",
    Japanese: "ライブラリ",
  },
  Legal:{
    English: "Legal",
    Japanese: "法律",
  },
  legal:{
    English: "legal",
    Japanese: "法律",
  },
  LastName:{
    English: "Last Name *",
    Japanese: "姓 *",
  },
  FirstName:{
    English: "First Name *",
    Japanese: "名 *",
  },
  Esther:{
    English: "Esther",
    Japanese: "エスター",
  },
  firstname:{
    English: "first name",
    Japanese: "名",
  },
  lastname:{
    English: "last name",
    Japanese: "姓",
  },
  interactive:{
    English: "interactive",
    Japanese: "対話型",
  },
  focusontheartsof:{
    English: "focus on the arts of",
    Japanese: "の真髄に焦点を当てています",
  },
  PractitionersFound:{
    Japanese: "施術士",
  },

};